import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatPhoneNumber, formatOpenDays } from '../../../utils/format';

const artlog_ip = process.env.REACT_APP_ARTLOG_IP;


export const TourDetail = ({ data, artistRecords }) => {
  const navigate = useNavigate();

  return (
    <>
    <div className="tour-detail__title-block">
      <div className="tour-detail__title-text">{data.tour_name}</div>
      <div className="tour-detail__title-tag">{data.tour_type}</div>
    </div>
    
    <div className="tour-detail__reservation-link" onClick={() => navigate(`/studio-detail/${data.id}`)}>
      예약 바로가기
    </div>

    {artistRecords.length > 0 && (
      <>
        <div className="tour-detail__info-text">작가노트 엿보기</div>
        <div className="tour-detail__artist-records">
          {artistRecords.map(record => (
            <img
              key={record.id}
              src={`${artlog_ip}:3541/${record.record_photo}`}
              alt={record.record_subject}
              className="tour-detail__artist-record-image"
            />
          ))}
        </div>
      </>
    )}

    <div className="tour-detail__info-text">정보</div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
      <div className="tour-detail__detail-text">{data.tour_location || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
      <div className="tour-detail__detail-text">{formatPhoneNumber(data.tour_phone)}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
      <div className="tour-detail__detail-text">{formatOpenDays(data.tour_open_days)}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
      <div className="tour-detail__detail-text">{data.tour_open_time}-{data.tour_close_time}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
      <div className="tour-detail__detail-text">{data.tour_website || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
      <div className="tour-detail__detail-text">{data.tour_description || '-'}</div>
    </div>

    <div className="tour-detail__map-buttons">
      <a href={`https://map.kakao.com/link/map/${data.tour_name},${data.tour_location_lat},${data.tour_location_lng}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
      </a>
      {/* <a href={`https://map.naver.com/v5/search/${data.tour_name}?c=/${data.tour_location_lng},${data.tour_location_lat}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
      </a> */}
      </div>
    </>
  )
}
